import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';
import * as XLSX from "xlsx";
import axiosInstance from '../services/AxiosInstance';
import fileSingle from '../ExcelFiles/name.xlsx';

// Sample Data
//<ExcelImport
//    headers={['Name', 'Code']}
//    url='job-categories-import/'
///>


const ExcelImport = ({
    headers = [],
    url = '',
    title = "",
    filePath = fileSingle,
    filename = "sample.xlsx",
    handleCloseExport
}) => {

    const [items, setItems] = useState([]);
    const [xl, setXl] = useState(null);

    useEffect(() => { }, [items]);

    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);

                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };

    const onSubmit = () => {
        axiosInstance(
            url, {
            method: "POST",
            timeout: 100000,
            data: items
        }
        ).then(res => {
            if (res.status === 200) {
                swal("", "Data Imported Successfully", "success", { button: "Ok!", });
                handleCloseExport();
            }
        }).catch(err => {
            swal("", (err.response.data?.detail?.join(', ')), "error", { button: "Ok!", });
        }).finally(() => {
            setItems([]);
            setXl(Math.random().toString(36))
        })
    }

    return (
        <>
            <div className="page-content bg-white">
                <div className="content-block">
                    <div className="section-full bg-white p-b20">
                        <div className="container">
                            <div className="job-bx-title  clearfix">
                                <h5 className="font-weight-700 pull-left text-uppercase">{title}</h5>
                                <div className="float-right" style={{ fontSize: "18px" }}>
                                    <a href={filePath} name="name" download={filename}>
                                        <i className="fa fa-download"> Download Template</i>
                                    </a>
                                </div>
                            </div>
                            <div className="job-bx browse-job clearfix">
                                <form className="attach-resume">
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group" style={{ border: "1px solid #e9e9e9" }}>
                                                <div className="custom-file">
                                                    <p className="m-auto align-self-center">
                                                        <i className="fa fa-upload"></i>
                                                        Select file (Allowed file formats - .xlsx, .xls, .csv, .ods)
                                                    </p>
                                                    <input
                                                        type="file"
                                                        className="site-button form-control"
                                                        id="customFile"
                                                        key={xl || ''}
                                                        name='cv'
                                                        accept='.xlsx, .xls, .csv, .ods'
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            readExcel(file);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                {
                                    items.length > 0 &&
                                    <>
                                        <button
                                            className="btn btn-sm mb-2 btn-primary float-right"
                                            onClick={onSubmit}
                                            disabled={items.length === 0}
                                        >
                                            Submit
                                        </button>
                                        <table className="table container">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    {
                                                        headers.map(res => <th key={res} sclope="col">{res}</th>)
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {items.map((d, index) => (
                                                    <tr key={d.name}>
                                                        <td>{index + 1}</td>
                                                        {
                                                            Object.keys(d).map(res => <td key={d[res]}>{d[res]}</td>)
                                                        }
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>


    );
};

export default ExcelImport;